import { useSelector } from 'react-redux';
import { invoicePdf, statementPdf } from '../selectors/PdfSelectors';

export const useInvoicePdf = invoiceId => useSelector(invoicePdf(invoiceId));

export const useStatementPdf = (accountNumber, date) => useSelector(statementPdf(accountNumber, date));
